import { Stack, Typography } from '@mui/material';

export const JsonPathParameterDescription = (): React.JSX.Element => (
  <Stack direction={'column'} spacing={1}>
    <Typography fontWeight={700} fontSize={12}>
      {'{path,to,property}=value'}
    </Typography>
    <Typography fontSize={12}>
      {'When the path points to an object, all properties will be searched recursively'}
    </Typography>
  </Stack>
);
